// extracted by mini-css-extract-plugin
export default {"getOutline":"Modal_getOutline__A4ChE","TextDialogButtons":"Modal_TextDialogButtons__Hk6OY","TextDialogPrimary":"Modal_TextDialogPrimary__jiuX-"};